/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @next/next/no-img-element */
import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import styles from "./client_review.module.scss";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import { getAssets } from "@unisearch/helpers";
import API from "@unisearch/helpers/api";
import { Grid, Rating } from "@mui/material";
import Carousel from "react-multi-carousel";
import { UniReviewCard } from "@modules/study/university/uni_reviews/components/uni_review_card";
import "react-multi-carousel/lib/styles.css";

export const ClientReview = ({ universityProfileData }) => {
  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);
  const [slider1, setSlider1] = useState(null);
  const [slider2, setSlider2] = useState(null);
  const [reviewList, setReviewList] = useState([]);

  // let imgNum;
  // if (data?.length <= 5) {
  //   imgNum = data?.length;
  // } else {
  //   imgNum = 6;
  // }

  function NextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <FiChevronRight
        className={`${className} ReviewSliderTextArrowNext`}
        onClick={onClick}
      />
    );
  }

  function PrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <FiChevronLeft
        className={`${className} ReviewSliderTextArrowPrev`}
        onClick={onClick}
      />
    );
  }

  useEffect(() => {
    setNav1(slider1);
    setNav2(slider2);
  });

  const settingsMain = {
    asNavFor: ".slider-nav",
    arrows: true,
    centerMode: false,
    infinite: false,
    centerPadding: "0px",
    slidesToShow: 1,
    speed: 500,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  const settingsThumbs = {
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: ".slider-for",
    dots: false,
    arrows: false,
    centerMode: true,
    focusOnSelect: false,
    swipeToSlide: false,
    draggable: false,
    responsive: [
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      // {
      //   breakpoint: 600,
      //   settings: {
      //     arrows: true,
      //     dots: false,
      //     centerMode: false,
      //     slidesToShow: 1,
      //     slidesToScroll: 1,
      //   },
      // },
    ],
  };

  const getData = async () => {
    await API.get(
      `/public/university-review/carousel?universitySlug=${universityProfileData?.universitySlug}&limit=6`
    )
      .then((res) => {
        if (!res.error) {
          const { data } = res;
          setReviewList(data);
        }
      })
      .catch((error) => {});
  };

  useEffect(() => {
    if (universityProfileData?.universitySlug) {
      getData();
    }
  }, [universityProfileData?.universitySlug]);

  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 1,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  return (
    <>
      {reviewList?.length > 0 ? (
        <section className={styles.section_review}>
          <div className="container">
            {reviewList && reviewList?.length < 5 ? (
              <div>
                <Carousel responsive={responsive} style={{ gap: "30px" }}>
                  {reviewList.map((item, i) => (
                    <div style={{ padding: "0 20px" }} key={i}>
                      <UniReviewCard item={item} />
                    </div>
                  ))}
                </Carousel>
              </div>
            ) : (
              <>
                <div
                  className={`${styles.review_slider_person} ReviewSliderPerson`}
                >
                  <Slider
                    {...settingsThumbs}
                    asNavFor={nav1}
                    ref={(slider) => setSlider2(slider)}
                  >
                    {reviewList &&
                      reviewList?.length > 0 &&
                      reviewList?.map((item, i) => (
                        <div
                          className={`${styles.review_person_image_wrapper} review_person_image_wrapper`}
                          key={i}
                        >
                          <img
                            src={
                              item?.profileImageSrc ??
                              getAssets("assets/uni_guest.png")
                            }
                            alt={item?.reviewerName}
                          />
                        </div>
                      ))}
                  </Slider>
                </div>
                {reviewList && reviewList?.length > 0 && (
                  <div className={styles.total_review_wrapper}>
                    <div className={styles.total_review_stars}>
                      <Rating
                        name="rating-read"
                        defaultValue={uniProfileData?.finalRating}
                        readOnly
                        sx={{ fontSize: "30px" }}
                      />
                      <div className={styles.rating}>
                        ({uniProfileData?.finalRating})
                      </div>
                    </div>
                    <div className={styles.total_review_text}>
                      Based on {uniProfileData?.totalRating}+ reviews
                    </div>
                  </div>
                )}

                {/* reveiw text */}
                <div className="ReviewSliderText">
                  <Slider
                    {...settingsMain}
                    asNavFor={nav2}
                    ref={(slider) => setSlider1(slider)}
                  >
                    {reviewList &&
                      reviewList?.length > 0 &&
                      reviewList?.map((item, i) => (
                        <div key={i}>
                          <div className={styles.review_info_wrapper}>
                            <p className={styles.review_text}>
                              {item?.reviewComment}
                            </p>
                            <div className={styles.review_divider}></div>

                            {item?.reviewerName && (
                              <div className={styles.review_name}>
                                {item?.reviewerName.trim()}
                              </div>
                            )}
                            <Rating
                              name="rating-read"
                              defaultValue={item?.rating}
                              readOnly
                            />
                          </div>
                        </div>
                      ))}
                  </Slider>
                </div>
              </>
            )}
          </div>
        </section>
      ) : (
        <></>
      )}
    </>
  );
};

export default ClientReview;
